'use strict';

/**
 * View for rendering the sets
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var NavigationSetsItemView = require('./navigation-sets-list-item');

var template = require('../../templates/partials/navigation-sets-list.hbs');

var NavigationSetsListView = ColidoCompositeView.extend({
    template: template,
    childView: NavigationSetsItemView,
    childViewContainer: 'ul',

    isVisible: false,

    collectionEvents: {
        'add remove': 'checkReveal',
    },

    onShow: function() {
        this.checkReveal();
    },

    onBeforeRender: function() {
        this.isVisible = this.$('ul').hasClass('is-visible');
    },

    onRender: function() {
        this.$('ul').toggleClass('is-visible', this.isVisible);
        this.prependOverviewItem();
    },

    prependOverviewItem: function() {
        var catalog = this.getOption('catalog');
        var prependItem = $('<li class="prepend-menu-item"><a href="/catalogs/' + catalog.id + '/sets">' + App.t('collection::sets:overview') + '</a></li>');
        this.$('ul').prepend(prependItem);
    },

    checkReveal: function() {
        this.$('ul').toggleClass('revealable', this.collection.length > 6);
    },
});

module.exports = NavigationSetsListView;